import React, { useState, useEffect } from "react";
import { cdnInstance } from "../axiosInterceptor";
import { ImageLink } from "../utils/constants";
import { toast } from "react-toastify";
import "./styles/Upload.css";

const UploadMultiImage = ({ 
  label = "Upload File", 
  initialImages = [], 
  onChange, 
  apiUrl 
}) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialImages && initialImages.length > 0) {
      const initialFiles = initialImages.map((path) => ({
        path,
        isVideo: checkIfVideo(path),
      }));
      setFiles(initialFiles);
    }
  }, [initialImages]);

  const checkIfVideo = (path) => /\.(mp4|webm|ogg)$/i.test(path);

  const handleChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (!selectedFiles.length) return;

    const MAX_VIDEO_SIZE_MB = 7;
    const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

    const validFiles = selectedFiles.filter(file => {
      if (checkIfVideo(file.name) && file.size > MAX_VIDEO_SIZE_BYTES) {
        toast.error(`Video "${file.name}" must be ≤ ${MAX_VIDEO_SIZE_MB} MB`);
        return false;
      }
      return true;
    });

    if (!validFiles.length) return;

    setLoading(true);

    const formData = new FormData();
    validFiles.forEach(file => formData.append("files", file));

    try {
      const response = await cdnInstance.post(`/${apiUrl}`, formData);
      if (response.status === 200) {
        const uploadedPaths = response.data.data || [];

const newFiles = uploadedPaths.map(item => ({
  path: item.path,
  isVideo: checkIfVideo(item.path),
}));


        setFiles(prev => {
          const updatedFiles = [...prev, ...newFiles];
          if (onChange) onChange(updatedFiles.map(f => f.path));
          return updatedFiles;
        });

        toast.success("Files uploaded successfully!");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Upload failed");
    }

    event.target.value = ""; 
    setLoading(false);
  };

  const copyToClipboard = (path) => {
    const fullUrl = ImageLink(path);
    navigator.clipboard.writeText(fullUrl)
      .then(() => toast.success("Copied to clipboard!"))
      .catch(() => toast.error("Failed to copy URL"));
  };

  const deleteFile = async (pathToDelete) => {
    try {
      const response = await cdnInstance.delete("/delete", { data: { image: pathToDelete } });
      if (response.status === 200) {
        toast.success(response.data?.message || "File deleted");
        const updatedFiles = files.filter(f => f.path !== pathToDelete);
        setFiles(updatedFiles);
        if (onChange) onChange(updatedFiles.map(f => f.path));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Delete failed");
    }
  };

  return (
    <div className="upload-component">
      <div className="upload-input-wrapper">
        <input
          type="file"
          accept="image/*,video/*"
          onChange={handleChange}
          className="form-control form-control-sm border-dark"
          multiple
          disabled={loading}
        />
        {loading && <div className="upload-loading">Uploading...</div>}
      </div>
      {files.length > 0 && (
        <div className="upload-preview-wrapper">
          {files.map((file, index) => (
            <div key={index} className="upload-preview">
              {file.isVideo ? (
                <video
                  src={ImageLink(file.path)}
                  className="preview-media"
                  autoPlay
                  loop
                  controls
                />
              ) : (
                <img
                  src={ImageLink(file.path)}
                  alt="Uploaded"
                  className="preview-media"
                />
              )}

              <div className="upload-actions">
                <button
                  type="button"
                  className="btn btn-sm btn-light me-1"
                  onClick={() => copyToClipboard(file.path)}
                  title="Copy URL"
                >
                  <i className="fas fa-copy text-primary"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={() => deleteFile(file.path)}
                  title="Delete"
                >
                  <i className="fas fa-trash text-danger"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UploadMultiImage;
